import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useField } from "@madmedical/form";
import BaseFormControl from "../molecules/Form/FormControl";
const getPattern = (type) => (type === "number" ? /^\d+([.,]\d+)?$/ : /.*/);
const FormControl = (props) => {
    const { control, isError, error } = useField(props.name);
    return (_jsx(Controller, { name: props.name, control: control, rules: {
            required: props.isRequired,
            pattern: getPattern(props.type),
        }, render: ({ field: { onBlur, onChange, value } }) => (_jsx(BaseFormControl, Object.assign({}, props, { onBlur: onBlur, onChange: onChange, value: value, isInvalid: isError, error: error }))) }));
};
export default FormControl;
